import { render, staticRenderFns } from "./sdkList.vue?vue&type=template&id=6ce8f20c&scoped=true&"
import script from "./sdkList.vue?vue&type=script&lang=js&"
export * from "./sdkList.vue?vue&type=script&lang=js&"
import style0 from "./sdkList.vue?vue&type=style&index=0&id=6ce8f20c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce8f20c",
  null
  
)

export default component.exports